function ServiceUnavailable(message) {
  this.name = "ServiceUnavailable";
  this.message = message || "";
  this.stack = new Error().stack;
}
ServiceUnavailable.prototype = Object.create(Error.prototype);
ServiceUnavailable.prototype.constructor = ServiceUnavailable;

export default ServiceUnavailable;
